// extracted by mini-css-extract-plugin
export default {"tip":"Tip_tip__70PiE","txt":"Tip_txt__Cvft6"};